import React from 'react';
import { Flex, Box, Divider, Button, Spacer } from '@chakra-ui/react';
import BEImageList from '@molecules/BEImageList';
import { useModal } from '@molecules/BEOffScreen';
import Gallery from '@view/components/Modals/Gallery';

const images = [
  {
    src: 'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
    thumb:
      'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
  },
  {
    src: 'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
    thumb: 'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
  },
];

const DemoImageList = () => {
  const galleryModal = useModal(Gallery, {});
  const handleOpenGalleryModal = (index?: number) => {
    galleryModal.open({
      index,
      images,
    });
  };

  return (
    <Box>
      <h2>Image List</h2>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <BEImageList
          gap={16}
          images={images.map((image) => image.thumb)}
          onClickItem={handleOpenGalleryModal}
          showDots={false}
        />
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Gallery</p>
        <Spacer />
        <Box>
          <Button onClick={() => handleOpenGalleryModal()}>Open</Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default DemoImageList;
